// @flow

import { registerMetricEventListeners, unregisterMetricEventListeners } from './metricEvents'
import { registerPosthogListeners, unregisterPosthogListeners } from './posthog'
import { registerWebAnalyticsListeners, unregisterWebAnalyticsListeners } from './webAnalytics'
import { registerChatchampPixelListeners, unregisterChatchampPixelListeners } from './chatchampPixel'

export function registerWizardEventListeners (): void {
  registerMetricEventListeners()
  registerPosthogListeners()
  registerWebAnalyticsListeners()
  registerChatchampPixelListeners()
}

export function unregisterWizardEventListeners (): void {
  unregisterMetricEventListeners()
  unregisterPosthogListeners()
  unregisterWebAnalyticsListeners()
  unregisterChatchampPixelListeners()
}
